import { CommonModule } from '@angular/common';
import dayjs from 'dayjs';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { ClientareaService } from 'src/app/shared/services/clientarea.service';
import { CommonCAEClass, ProfessionalsituationClass } from 'src/app/shared/models/common-class';
import {
  CustomerClass,
  CustomerEmail,
  CustomerLayoutClass,
  CustomerShipToAddressClass,
  UserMyManagersClass,
  UserMyManagersContactsClass,
} from 'src/app/shared/models/customer-class';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { environment } from 'src/environments/environment';
import { UploadFilesClass } from '../../models/uploads-class';
import { CommonService } from '../../services/common.service';
import { ImageService } from '../../services/image.service';
import { UploadService } from '../../services/upload.service';
import { UsersService } from '../../services/users.service';
import { AccessService } from '../../services/access.service';
import { ValidateService } from '../../services/validate.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DATE_ADAPTER_PROVIDERS } from 'src/app/shared/providers/date-adapter.providers';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LoadingComponent } from '../loading/loading.component';
import { NavigationEnd, Router } from '@angular/router';
import { LoaddefaultdataService } from '../../services/loaddefaultdata.service';
import { GlobalService } from '../../services/global.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AlertMessageService } from '../../services/alert-message.service';
import { RealtimeService } from '../../services/realtime.service';
import { ValidateNifService } from '../../services/validatenif.service';
import { ConvertImageToUrlPipe } from 'src/app/shared/pipes/convert-image-to-url.pipe';
import Swal from '../../services/swal-compat';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { SafeUrl } from '@angular/platform-browser';
import { ProfilePhotoService } from '../../services/profile-photo.service';
import { WhatsappSettingsService } from '../../services/whatsapp-settings.service';

@Component({
  standalone: true,
  selector: 'app-usermenu',
  templateUrl: './usermenu.component.html',
  styleUrls: ['./usermenu.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDividerModule,
    MatMenuModule,
    MatExpansionModule,
    MatAutocompleteModule,
    TranslateModule,
    LoadingComponent,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    ConvertImageToUrlPipe,
    UserAvatarComponent,
  ],
  providers: [DATE_ADAPTER_PROVIDERS],
})
export class UsermenuComponent implements OnChanges, OnDestroy, OnInit {
  destroy$ = new Subject<void>();
  private subscriptions: Subscription[] = [];
  lastTouchTime: number = 0;
  doubleClickThreshold: number = 300;
  private currentCustomerId?: number;
  showButtonSave: boolean;
  showButtonAdd: boolean;
  showButtonEdit: boolean;
  antesUserMyManagersContactsClass: UserMyManagersContactsClass;
  whatsappSharedAccounts: any[] = [];
  isWhatsAppChannelAvailable = false;

  googleStatus: {
    linked: boolean;
    googleEmail: string | null;
    linkedAt: string | null;
    pictureDataUrl: string | null;
    linkedProfiles: Array<{
      idUser?: number;
      nif: string;
      name: string;
      isCompany: boolean;
      relation: 'direct' | 'authorized';
    }>;
  } = {
    linked: false,
    googleEmail: null,
    linkedAt: null,
    pictureDataUrl: null,
    linkedProfiles: [],
  };
  isLoadingGoogle = false;
  linkAuthorizedNifs = true;

  get googleAccountInitial(): string {
    const email = (this.googleStatus?.googleEmail || '').trim();
    return email ? email.charAt(0).toUpperCase() : 'G';
  }

  /** Indica se existe pelo menos uma conta partilhada com WhatsApp ativo */
  get hasActiveSharedWhatsApp(): boolean {
    return this.whatsappSharedAccounts?.some(a => a.AllowWhatsApp) ?? false;
  }

  private _cachedAreas: { path: string; label: string; icon: string }[] = [];
  private _lastUserKeys: string = '';
  private showCRM: boolean = false;
  private showCRMMediador: boolean = false;
  private lastCheckedUserId: number | null = null;
  private lastCheckedUserToken: string | null = null;

  async checkAreasAccess(force = false): Promise<void> {
    try {
      const user = this.globalService.loggedUserClass;
      const currentUserId = user?.idUser ?? null;
      const currentToken = user?.Token ?? null;

      if (!this.authService.isLoggedin(user)) {
        this.showCRM = false;
        this.showCRMMediador = false;
        this.lastCheckedUserId = null;
        this.lastCheckedUserToken = null;
        this._lastUserKeys = '';
        this.cdr.detectChanges();
        return;
      }

      if (!force && currentUserId === this.lastCheckedUserId && currentToken === this.lastCheckedUserToken) {
        return;
      }
      this.lastCheckedUserId = currentUserId;
      this.lastCheckedUserToken = currentToken;

      // Garantir que as flags de área em memória estão sincronizadas com o JWT atual
      if (currentToken) {
        try {
          const parts = String(currentToken).split('.');
          if (parts.length === 3) {
            let payloadB64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            while (payloadB64.length % 4) payloadB64 += '=';
            const decoded = JSON.parse(atob(payloadB64));
            if (decoded) {
              if (decoded.Admin !== undefined) user.Admin = !!decoded.Admin;
              if (decoded.ClientArea !== undefined) user.ClientArea = !!decoded.ClientArea;
              if (decoded.CommercialArea !== undefined) user.CommercialArea = !!decoded.CommercialArea;
              if (decoded.IntermediaryArea !== undefined) user.IntermediaryArea = !!decoded.IntermediaryArea;
              if (decoded.SiteManagement !== undefined) user.SiteManagement = !!decoded.SiteManagement;
              if (!user.NavigateTo && decoded.NavigateTo) user.NavigateTo = decoded.NavigateTo;
            }
          }
        } catch {
          // Ignorar erro de parse de token
        }
      }

      if (user?.Admin) {
        this.showCRM = true;
        this.showCRMMediador = true;
      } else {
        const [hasCrm, hasCrmMediador] = await Promise.all([
          this.accessService.GetUsersAccessValidate('CRM', 'Aceder ao CRM').catch(() => false),
          this.accessService.GetUsersAccessValidate('CRM Mediador', 'Aceder ao CRM Mediador').catch(() => false),
        ]);
        this.showCRM = hasCrm;
        this.showCRMMediador = hasCrmMediador;
      }

      this._lastUserKeys = '';
      this.cdr.detectChanges();
    } catch (e) {
      console.warn('[UserMenu] Erro ao verificar acesso às áreas:', e);
    }
  }

  get availableAreas(): { path: string; label: string; icon: string }[] {
    const user = this.globalService.loggedUserClass;
    if (!user) return [];

    if (
      user.idUser &&
      user.Token &&
      (user.idUser !== this.lastCheckedUserId || user.Token !== this.lastCheckedUserToken)
    ) {
      this.checkAreasAccess();
    }

    const keys = `${user.idUser}-${user.NIF}-${!!user.ClientArea}-${!!user.IntermediaryArea}-${!!user.SiteManagement}-${this.showCRM}-${this.showCRMMediador}-${!!user.Admin}`;
    if (this._lastUserKeys !== keys) {
      this._lastUserKeys = keys;
      const areas: { path: string; label: string; icon: string }[] = [
        { path: '/home', label: 'Homepage', icon: 'home' },
      ];

      if (user.ClientArea || user.IntermediaryArea || user.CommercialArea || user.SiteManagement || user.Admin) {
        areas.push({ path: '/clientarea', label: 'Área do Cliente', icon: 'person_outline' });
      }
      if (user.IntermediaryArea || user.Admin) {
        areas.push({ path: '/intermediaryarea', label: 'Área do Parceiro', icon: 'handshake' });
      }
      if (this.showCRM || user.Admin) {
        areas.push({ path: '/crm', label: 'CRM ADM', icon: 'dashboard_customize' });
      }
      if (this.showCRMMediador || user.Admin) {
        areas.push({ path: '/crm-mediador', label: 'CRM Mediadores', icon: 'storefront' });
      }
      if (user.SiteManagement || user.Admin) {
        areas.push({ path: '/admin', label: 'Configurações', icon: 'settings' });
      }
      this._cachedAreas = areas;
    }

    return this._cachedAreas;
  }

  @ViewChild('formData') formData: NgForm;

  today: any;
  tomorrow: any;
  MaiorIdade: any;
  MaiorIdadeHoje: any;
  menu?: string;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('fileInput2') fileInput2: ElementRef;
  @Input() option: MatDrawer;
  @Output() outuserPhoto = new EventEmitter<ElementRef>();

  ManagersClass: UserMyManagersClass;
  telMyManagersContactsClass: UserMyManagersContactsClass;
  emailUserMyManagersContactsClass: UserMyManagersContactsClass;
  MyManagersAddForm: boolean;

  showProgress: boolean;

  @ViewChild('pickerBirthdate') Birthdate;
  @ViewChild('pickerDrivinglicenseDate') DrivinglicenseDate;

  showSpinnerShipToAddress: boolean;
  tempcustomerShipToAddressClass: CustomerShipToAddressClass;

  filteredOptions: Observable<string[]>;
  professions: ProfessionalsituationClass[];
  commonCAE: CommonCAEClass[];

  constructor(
    public globalService: GlobalService,
    public authService: AuthService,
    private customerService: CustomerService,
    public dialog: MatDialog,
    public clientareaService: ClientareaService,
    private uploadService: UploadService,
    private usersService: UsersService,
    private accessService: AccessService,
    private commonService: CommonService,
    public validateService: ValidateService,
    public validateNifService: ValidateNifService,
    public imageService: ImageService,
    private router: Router,
    public loaddefaultdataService: LoaddefaultdataService,
    public baseService: BaseService,
    private cdr: ChangeDetectorRef,
    private realtime: RealtimeService,
    private alerts: AlertMessageService,
    private t: TranslateService,
    public profilePhotoService: ProfilePhotoService,
    private whatsappSettingsService: WhatsappSettingsService,
  ) {
    if (globalService.loggedUserClass && !globalService.loggedUserClass.customerClass) {
      globalService.loggedUserClass.customerClass = new CustomerClass();
    }

    this.showButtonSave = false;
    this.showButtonAdd = !this.showButtonSave;

    this.showProgress = false;
    this.today = dayjs().toDate();
    this.tomorrow = dayjs().add(1, 'day').startOf('day').toDate();
    this.MaiorIdade = dayjs().subtract(18, 'year').toDate();
    this.MaiorIdadeHoje = dayjs().toDate();
    this.tempcustomerShipToAddressClass = new CustomerShipToAddressClass();
    this.tempcustomerShipToAddressClass.AddressDetail = '';
    this.tempcustomerShipToAddressClass.Country = '';
    this.tempcustomerShipToAddressClass.Description = '';
    this.tempcustomerShipToAddressClass.PostalCode = '';
    this.tempcustomerShipToAddressClass.Region = '';
    this.menu = 'cliente';
    this.MyManagersAddForm = false;

    this.ManagersClass = new UserMyManagersClass();
    this.telMyManagersContactsClass = new UserMyManagersContactsClass();
    this.emailUserMyManagersContactsClass = new UserMyManagersContactsClass();
    this.showButtonEdit = false;

    this.professions = this.globalService.professionalsituationClass;
    this.commonCAE = this.globalService.commonCAEClass;
  }

  get isCompany(): boolean {
    return this.validateNifService.isNIFEmpresa(this.globalService.loggedUserClass?.customerClass?.NIF);
  }

  /** Filtra tipos de sexo consoante o tipo de NIF (empresa vs. pessoal) */
  get filteredSexTypes() {
    return (this.globalService.sexTypesClass || []).filter(t => !!t.isCompany === this.isCompany);
  }

  get isIBANInvalid(): boolean {
    const rawNib = String(this.globalService.loggedUserClass?.customerClass?.NIB || '')
      .replace(/^PT50/i, '')
      .replace(/\D/g, '')
      .trim();
    return rawNib.length > 0 && this.validateService.isValidIBANNumber(rawNib) !== 1;
  }

  private _drawerSubscribed: boolean = false;

  /**
   * Indica se existe algum alerta de perfil ou de apólice pendente associado ao cliente
   */
  get hasProfileAlert(): boolean {
    const cust = this.globalService.loggedUserClass?.customerClass;
    if (!cust) return false;
    if (cust.alertUser && cust.alertUser.length > 0) return true;
    if (
      this.globalService.alertGeralMenuUser?.faltaCC ||
      this.globalService.alertGeralMenuUser?.faltaCartaConducao ||
      this.globalService.alertGeralMenuUser?.AlertButon === 'ClientOutros'
    ) {
      return true;
    }
    return false;
  }

  /**
   * Extrai e normaliza todas as mensagens e detalhes dos alertas do cliente
   */
  private getRelevantAlertMessages(): string[] {
    const cust = this.globalService.loggedUserClass?.customerClass;
    if (!cust) return [];
    const alerts = [...(cust.alertUser || []), ...(cust.alertClientAreaInsurances || [])];
    return alerts.map(a => `${a.message || ''} ${a.detail || ''}`.toLowerCase()).filter(m => m.trim().length > 0);
  }

  /**
   * Verifica se alguma mensagem de alerta contém alguma das palavras-chave especificadas
   */
  private alertMentions(keywords: string[]): boolean {
    const msgs = this.getRelevantAlertMessages();
    return msgs.some(m => keywords.some(k => m.includes(k.toLowerCase())));
  }

  /**
   * Avalia defensivamente se um campo específico da ficha de cliente está em falta ou inválido
   */
  isFieldMissing(field: string): boolean {
    const cust = this.globalService.loggedUserClass?.customerClass;
    if (!cust) return false;

    switch (field) {
      case 'Name': {
        const isEmpty = !cust.Name || cust.Name.trim() === '';
        return isEmpty && (this.alertMentions(['nome']) || this.hasProfileAlert);
      }
      case 'AddressDetail': {
        const isEmpty = !cust.AddressDetail || cust.AddressDetail.trim() === '';
        return (
          isEmpty &&
          (this.alertMentions(['morada', 'endereço', 'endereco', 'código postal', 'codigo postal', 'postal']) ||
            this.hasProfileAlert)
        );
      }
      case 'Birthdate': {
        if (this.isCompany) return false;
        const isEmpty = !cust.Birthdate;
        return isEmpty && (this.alertMentions(['nascimento', 'data de nasc']) || this.hasProfileAlert);
      }
      case 'idSexTypes': {
        if (this.isCompany) return false;
        const isEmpty = !cust.idSexTypes;
        return isEmpty && (this.alertMentions(['género', 'genero', 'sexo']) || this.hasProfileAlert);
      }
      case 'Drivinglicense': {
        if (this.isCompany) return false;
        const isEmpty = !cust.Drivinglicense || cust.Drivinglicense.trim() === '';
        return (
          isEmpty &&
          this.alertMentions(['carta de condução', 'carta de conducao', 'condução caducada', 'conducao caducada'])
        );
      }
      case 'DrivinglicenseDate': {
        if (this.isCompany) return false;
        const isEmpty = !cust.DrivinglicenseDate;
        return isEmpty && this.alertMentions(['carta de condução', 'carta de conducao', 'data da carta']);
      }
      case 'idMaritalStatus': {
        if (this.isCompany) return false;
        const isEmpty = !cust.idMaritalStatus;
        return isEmpty && (this.alertMentions(['estado civil']) || this.hasProfileAlert);
      }
      case 'Contact': {
        const isEmpty = !cust.Contact || cust.Contact.trim() === '' || cust.Contact.length < 9;
        return (
          isEmpty &&
          (this.alertMentions(['contacto', 'contato', 'telefone', 'telemóvel', 'telemovel']) || this.hasProfileAlert)
        );
      }
      case 'Profession': {
        if (this.isCompany) return false;
        const isEmpty = !cust.Profession || cust.Profession.trim() === '';
        return isEmpty && (this.alertMentions(['profissão', 'profissao']) || this.hasProfileAlert);
      }
      case 'CAE': {
        if (!this.isCompany) return false;
        const isEmpty = !cust.CAE || cust.CAE.trim() === '';
        return isEmpty && (this.alertMentions(['cae', 'atividade', 'actividade']) || this.hasProfileAlert);
      }
      case 'NIB': {
        const rawNib = String(cust.NIB || '')
          .replace(/^PT50/i, '')
          .replace(/\D/g, '')
          .trim();
        const isInvalid = rawNib.length > 0 && this.validateService.isValidIBANNumber(rawNib) !== 1;
        const hasNibAlert = this.alertMentions(['nib', 'iban']);
        return (hasNibAlert && rawNib.length === 0) || isInvalid;
      }
      case 'Email': {
        const emailVal = (cust.Email || '').trim();
        const isEmptyOrInvalid = !emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
        return isEmptyOrInvalid && (this.alertMentions(['email']) || this.hasProfileAlert);
      }
      case 'faltaCC': {
        return (
          !!this.globalService.alertGeralMenuUser?.faltaCC ||
          cust.alertUser?.some(a => a.faltaCC) ||
          this.alertMentions([
            'cartão de cidadão',
            'cartao de cidadao',
            'falta cc',
            'documento de identificação',
            'identificacao',
          ])
        );
      }
      case 'ClientOutros': {
        return (
          this.globalService.alertGeralMenuUser?.AlertButon === 'ClientOutros' ||
          !!this.globalService.alertGeralMenuUser?.faltaCartaConducao ||
          cust.alertUser?.some(a => a.faltaCartaConducao) ||
          this.alertMentions(['carta de condução', 'carta de conducao', 'condução caducada', 'conducao caducada'])
        );
      }
      default:
        return false;
    }
  }

  get defaultProfileImage(): string {
    return this.imageService.criarImagemClienteDefault(
      '#dcdcdc',
      this.globalService.loggedUserClass?.customerClass?.Name,
      '#1b1464',
      45,
    );
  }

  /** Iniciais do mediador para o avatar (evita .split() no template) */
  get mediatorInitials(): string {
    const name = this.globalService.loggedUserClass?.commercialClass?.Name || '';
    const parts = name
      .trim()
      .split(' ')
      .filter(p => p.length > 0);
    if (parts.length === 0) return '';
    const first = parts[0].charAt(0).toUpperCase();
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0).toUpperCase() : '';
    return first + last;
  }

  /** Serializa managers + mediatorServices no campo MyManager (JSON wrapper) */
  private serializeManagerData(): void {
    const cc = this.globalService.loggedUserClass?.customerClass;
    if (!cc) return;
    cc.MyManager = JSON.stringify({
      managers: cc.useMyManagersClass || [],
      mediatorServices: cc.MediatorServices || '',
    });
  }

  /** Parseia MyManager (suporta formato antigo [array] e novo {wrapper}) */
  private parseManagerData(raw: any): void {
    const cc = this.globalService.loggedUserClass?.customerClass;
    if (!cc) return;
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (Array.isArray(parsed)) {
        // Formato antigo — apenas array de managers
        cc.useMyManagersClass = parsed;
        // Manter mediatorServices existente
      } else if (parsed && typeof parsed === 'object') {
        // Formato novo — wrapper com managers + mediatorServices
        cc.useMyManagersClass = parsed.managers || [];
        cc.MediatorServices = parsed.mediatorServices || '';
      } else {
        cc.useMyManagersClass = [];
      }
    } catch (e) {
      console.error('Erro ao parsear MyManager:', e);
      cc.useMyManagersClass = [];
    }
  }

  // =========================
  // Ciclo de vida
  // =========================
  ngOnInit(): void {
    // 0) Verificar Acesso Localmente ou API para as Áreas (Igual ao Fullmenu)
    this.checkAreasAccess(true);

    // Revalidar acessos sempre que haja navegação, login/troca de perfil ou restauro de sessão
    this.subscriptions.push(
      this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
        if (e instanceof NavigationEnd) {
          this.checkAreasAccess();
        }
      }),
    );

    this.subscriptions.push(
      this.globalService.loginSuccess$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.checkAreasAccess(true);
        this.refresh(false);
        this.cdr.detectChanges();
      }),
    );

    this.subscriptions.push(
      this.globalService.isRestoringSession$.pipe(takeUntil(this.destroy$)).subscribe(isRestoring => {
        if (!isRestoring) {
          this.checkAreasAccess(true);
        }
      }),
    );

    // 1) garantir ligação ao socket
    this.realtime.connect();

    this.whatsappSettingsService
      .getPublicStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: res => {
          this.isWhatsAppChannelAvailable = Boolean(res && res.isAvailable);
          this.cdr.markForCheck();
        },
        error: () => {
          this.isWhatsAppChannelAvailable = false;
        },
      });

    // 2) entrar na sala (se já houver id) — caso não haja, refresh tratará disto
    this.maybeJoinCustomerRoom();

    // Quando o perfil for atualizado (foto alterada)
    this.subscriptions.push(
      this.globalService.profilePhotoLoaded$.pipe(takeUntil(this.destroy$)).subscribe(loaded => {
        if (loaded) {
          this.cdr.detectChanges();
        }
      }),
    );

    // Subscrever abertura do drawer para refrescar alertas e áreas acessíveis em tempo real
    if (this.option) {
      this._drawerSubscribed = true;
      this.subscriptions.push(
        this.option.openedChange.pipe(takeUntil(this.destroy$)).subscribe(opened => {
          if (opened) {
            this.onDrawerOpened();
          }
        }),
      );
    }

    // 3) subscrições realtime
    this.subscriptions.push(
      this.realtime.customerPatched$.pipe(takeUntil(this.destroy$)).subscribe(evt => {
        if (!evt) return;
        if (evt.id !== this.currentCustomerId) return;

        const target = this.globalService?.loggedUserClass?.customerClass;
        if (target) {
          Object.assign(target, evt.patch);
          if (typeof target.parseDates === 'function') target.parseDates();
          this.cdr.detectChanges();
        }
      }),
    );

    this.subscriptions.push(
      this.realtime.customerSectionChanged$.pipe(takeUntil(this.destroy$)).subscribe(e => {
        if (!e) return;
        if (e.idCustomer !== this.currentCustomerId) return;

        const cust = this.globalService?.loggedUserClass?.customerClass;
        if (!cust) return;

        const curId = this.currentCustomerId;
        const row = e.payload;
        if (!row) return;
        if (row.idCustomer !== curId) return;
        // Guardar foto antes da sobreposição (o payload realtime não traz o blob Photo)
        const prevPhotoRT = this.globalService.loggedUserClass.customerClass.Photo;
        const prevPhotoPathRT = this.globalService.loggedUserClass.customerClass.PhotoPath;
        Object.assign(this.globalService.loggedUserClass.customerClass, row);
        if (prevPhotoRT && !this.globalService.loggedUserClass.customerClass.Photo) {
          if (
            !this.globalService.loggedUserClass.customerClass.PhotoPath ||
            this.globalService.loggedUserClass.customerClass.PhotoPath === prevPhotoPathRT
          ) {
            this.globalService.loggedUserClass.customerClass.Photo = prevPhotoRT;
          }
        }
        if (typeof this.globalService.loggedUserClass.customerClass.parseDates === 'function') {
          this.globalService.loggedUserClass.customerClass.parseDates();
        }
        this.cdr.markForCheck();

        switch (e.section) {
          case 'shipTo':
            if (e.payload?.AddressDetail !== undefined) cust.AddressDetail = e.payload.AddressDetail;
            if (e.payload?.PostalCode !== undefined) cust.PostalCode = e.payload.PostalCode;
            if (e.payload?.Region !== undefined) cust.Region = e.payload.Region;
            if (e.payload?.Country !== undefined) cust.Country = e.payload.Country;
            if (e.payload?.idShipToAddress !== undefined) {
              cust.idShipToAddressDefault = e.payload.idShipToAddress ?? cust.idShipToAddressDefault;
            }
            break;
          case 'emails':
            if (e.payload?.EmailAddress) cust.Email = e.payload.EmailAddress;
            break;
          case 'nib':
            if (e.payload?.IBAN) cust.NIB = e.payload.IBAN;
            break;
          default:
        }

        this.cdr.detectChanges();
      }),
    );

    // 👇 NOVO: sincronizar ficheiros (CC / carta condução) vindos de outra sessão
    this.subscriptions.push(
      this.realtime.customerFilesChanged$.pipe(takeUntil(this.destroy$)).subscribe(msg => {
        if (!msg) return;
        const curId = this.currentCustomerId;
        if (msg.idCustomer !== curId) return;

        const cust = this.globalService.loggedUserClass?.customerClass as any;
        if (!cust) return;
        if (msg.section === 'citizenCard') {
          cust.customerFilesCitizenCardClass = msg.files;
        } else if (msg.section === 'driveLicense') {
          cust.customerFilesDriveLicenseClass = msg.files;
        }
        this.cdr.detectChanges();
      }),
    );

    // 4) carregar dados (e garantir entrada na sala ao terminar)
    this.refresh(false);
  }

  private onDrawerOpened(): void {
    this.checkAreasAccess(true);

    if (this.globalService.loggedUserClass) {
      this.subscriptions.push(
        this.commonService
          .SetSiteRoutesLog(
            this.globalService.loggedUserClass.idUser,
            'Cliente / Gestor',
            this.menu,
            this.globalService.loggedUserClass.UUID,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({ error: error => console.log(error) }),
      );
    }

    const cust = this.globalService.loggedUserClass?.customerClass;
    if (cust) {
      if (cust.AllowWhatsApp) {
        this.loadWhatsAppSharedAccounts();
      }
      this.loadGoogleStatus();
      this.clientareaService.CheckDataclient(cust);
    }
    this.cdr.detectChanges();
  }

  ngOnChanges(): void {
    // se algum @Input mudar (ex.: drawer), não precisamos recarregar o cliente aqui
    this.showSpinnerShipToAddress = false;

    if (this.option && !this._drawerSubscribed) {
      this._drawerSubscribed = true;
      this.subscriptions.push(
        this.option.openedChange.pipe(takeUntil(this.destroy$)).subscribe(opened => {
          if (opened) {
            this.onDrawerOpened();
          }
        }),
      );
    }
  }

  ngOnDestroy() {
    try {
      if (this.currentCustomerId) {
        this.realtime.leaveCustomer(this.currentCustomerId);
      }
      if (!this.destroy$.closed) {
        this.destroy$.next();

        this.destroy$.complete();
      }
      this.subscriptions.forEach(sub => sub.unsubscribe());
    } catch (error) {}
  }

  private getSwal() {
    return Promise.resolve(Swal);
  }

  // =========================
  // Realtime helpers
  // =========================
  private maybeJoinCustomerRoom() {
    const id = this.globalService?.loggedUserClass?.customerClass?.idCustomer;
    if (!id) {
      return;
    }
    if (this.currentCustomerId === id) return;

    if (this.currentCustomerId) {
      this.realtime.leaveCustomer(this.currentCustomerId);
    }

    this.currentCustomerId = id;
    this.realtime.joinCustomer(id);
  }

  // =========================
  // Ações
  // =========================
  editManager(before: any) {
    this.antesUserMyManagersContactsClass = new UserMyManagersContactsClass();
    this.antesUserMyManagersContactsClass = before;
  }

  cancelManager(_before: any) {
    _before = this.antesUserMyManagersContactsClass;
  }

  save(refresh: boolean) {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    if (!this.validateNifService.isNIFEmpresa(this.globalService.loggedUserClass.customerClass.NIF)) {
      if (this.globalService.loggedUserClass.customerClass.Birthdate) {
        const today = new Date();
        if (this.globalService.loggedUserClass.customerClass.Birthdate > today) {
          this.getSwal().then(swal => swal.fire({ icon: 'error', text: this.t.instant('USERMENU.INVALID_BIRTHDATE') }));
          return;
        }
      }
    }

    if (this.globalService.loggedUserClass.customerClass.NIB !== undefined) {
      this.globalService.loggedUserClass.customerClass.NIB = String(
        this.globalService.loggedUserClass.customerClass.NIB || '',
      )
        .replace(/^PT50/i, '')
        .replace(/\D/g, '')
        .trim();

      if (
        this.globalService.loggedUserClass.customerClass.NIB.length > 0 &&
        this.validateService.isValidIBANNumber(this.globalService.loggedUserClass.customerClass.NIB) !== 1
      ) {
        this.getSwal().then(swal => swal.fire({ icon: 'error', text: this.t.instant('USERMENU.INVALID_IBAN') }));
        return;
      }
    }

    this.serializeManagerData();

    this.subscriptions.push(
      this.customerService
        .ClientAreaSetCustomer(
          this.globalService.loggedUserClass.customerClass,
          this.globalService.loggedUserClass.UUID,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (d: any) => {
            if (!this.globalService.loggedUserClass?.customerClass) return;
            const customerData = Array.isArray(d) ? d[0] : d;
            if (customerData) {
              // Preservar dados do frontend antes do Object.assign — a API não retorna estes campos
              const savedManagers = this.globalService.loggedUserClass.customerClass.useMyManagersClass;
              const savedServices = this.globalService.loggedUserClass.customerClass.MediatorServices;
              const savedPhotoSave = this.globalService.loggedUserClass.customerClass.Photo;
              const savedPhotoPathSave = this.globalService.loggedUserClass.customerClass.PhotoPath;
              Object.assign(this.globalService.loggedUserClass.customerClass, customerData);
              // Restaurar foto se a API não trouxe blob
              if (savedPhotoSave && !this.globalService.loggedUserClass.customerClass.Photo) {
                if (
                  !this.globalService.loggedUserClass.customerClass.PhotoPath ||
                  this.globalService.loggedUserClass.customerClass.PhotoPath === savedPhotoPathSave
                ) {
                  this.globalService.loggedUserClass.customerClass.Photo = savedPhotoSave;
                }
              }
              this.globalService.loggedUserClass.customerClass.parseDates();

              // Re-parsear MyManager da API ou restaurar os dados preservados
              if (this.globalService.loggedUserClass.customerClass.MyManager) {
                this.parseManagerData(this.globalService.loggedUserClass.customerClass.MyManager);
              } else {
                this.globalService.loggedUserClass.customerClass.useMyManagersClass = savedManagers || [];
                this.globalService.loggedUserClass.customerClass.MediatorServices = savedServices || '';
              }

              this.cdr.detectChanges();
            }
          },
          error: error => {
            this.showProgress = false;
            if (window.navigator.onLine) {
              this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
            }
            console.log(error);
          },
          complete: () => {
            if (!this.globalService.loggedUserClass?.customerClass) return;
            if (refresh) {
              this.refresh(true);
            }

            this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
            this.cdr.detectChanges();
            // garantir que ficas na sala certa após gravação
            this.maybeJoinCustomerRoom();
          },
        }),
    );
  }

  savecustomerShipToAddressClass() {
    if (
      this.tempcustomerShipToAddressClass.AddressDetail ||
      this.tempcustomerShipToAddressClass.PostalCode ||
      this.tempcustomerShipToAddressClass.Region
    ) {
      this.subscriptions.push(
        this.customerService
          .ClientAreaSetCustomerShipToAddress(
            this.tempcustomerShipToAddressClass,
            this.globalService.loggedUserClass.UUID,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            error: error => {
              if (window.navigator.onLine) {
                this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
              }
              console.log(error);
            },
          }),
      );
    }
  }

  saveNavigateTo() {
    if (!this.globalService.loggedUserClass) return;

    this.subscriptions.push(
      this.usersService
        .SetUsersInitialPage(
          this.globalService.loggedUserClass.idUser,
          this.globalService.loggedUserClass.NavigateTo,
          this.globalService.loggedUserClass.UUIDLastChange || this.globalService.loggedUserClass.UUID,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.authService.saveSession(this.globalService.loggedUserClass);
            this.cdr.detectChanges();
          },
          error: error => {
            console.error('Erro ao guardar opção NavigateTo:', error);
            this.globalService.loggedUserClass.NavigateTo = '/clientarea';
            this.cdr.detectChanges();
            if (window.navigator.onLine) {
              this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
            }
          },
        }),
    );
  }

  cancel() {}

  /** Chamado quando o toggle AllowWhatsApp muda */
  onWhatsAppToggle(): void {
    if (this.globalService.loggedUserClass?.customerClass?.AllowWhatsApp) {
      this.loadWhatsAppSharedAccounts();
    } else {
      this.whatsappSharedAccounts = [];
    }
  }

  /** Carrega contas que partilham o mesmo telemóvel via API */
  private loadWhatsAppSharedAccounts(): void {
    const idCustomer = this.globalService.loggedUserClass?.customerClass?.idCustomer;
    if (!idCustomer) return;

    this.subscriptions.push(
      this.customerService
        .GetWhatsAppSharedAccess(idCustomer)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any[]) => {
            this.whatsappSharedAccounts = data || [];
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.warn('Erro ao carregar contas WhatsApp partilhadas:', err);
            this.whatsappSharedAccounts = [];
          },
        }),
    );
  }

  refresh(force = false) {
    if (this.globalService.isChangeNIFInProgress) {
      console.log('[UserMenu] Refresh ignorado: Troca de NIF em curso.');
      return;
    }

    this.checkAreasAccess();

    if (this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      const cust = this.globalService.loggedUserClass?.customerClass;

      // Se já foi carregado no arranque (loadCustomerUser) e não é um refresh forçado pós-edição,
      // reaproveitar os dados em memória sem duplicar chamadas de rede nem descarregar a foto 3 vezes.
      if (!force && cust?.idCustomer && cust?.NIF) {
        if (cust.MyManager) {
          this.parseManagerData(cust.MyManager);
        } else {
          cust.useMyManagersClass = [];
          cust.MediatorServices = '';
        }
        this.maybeJoinCustomerRoom();
        this.cdr.detectChanges();
        return;
      }

      // Usar customerClass.NIF ou loggedUserClass.NIF como fallback, garantindo que não há espaços
      const nif = (cust?.NIF || this.globalService.loggedUserClass?.NIF || '').trim();

      if (!nif) {
        console.warn('NIF não disponível para refresh');
        return;
      }

      this.subscriptions.push(
        this.customerService
          .ClientAreaGetCustomerNIF(nif)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (customer: any) => {
              if (!this.globalService.loggedUserClass) return;
              // A API pode retornar array ou objeto único dependendo da versão
              const customerData = Array.isArray(customer) ? customer[0] : customer;

              if (customerData) {
                // Garantir instância para o parseDates funcionar (essencial após restore de sessão)
                if (!(this.globalService.loggedUserClass.customerClass instanceof CustomerClass)) {
                  this.globalService.loggedUserClass.customerClass = new CustomerClass();
                }

                // Guardar foto antes da sobreposição
                const prevPhotoNIF = this.globalService.loggedUserClass.customerClass.Photo;
                const prevPhotoPathNIF = this.globalService.loggedUserClass.customerClass.PhotoPath;
                // Atualizar a instância existente em vez de substituir a referência
                Object.assign(this.globalService.loggedUserClass.customerClass, customerData);
                // Restaurar foto se a API não trouxe blob
                if (prevPhotoNIF && !this.globalService.loggedUserClass.customerClass.Photo) {
                  if (
                    !this.globalService.loggedUserClass.customerClass.PhotoPath ||
                    this.globalService.loggedUserClass.customerClass.PhotoPath === prevPhotoPathNIF
                  ) {
                    this.globalService.loggedUserClass.customerClass.Photo = prevPhotoNIF;
                  }
                }
                this.globalService.loggedUserClass.customerClass.parseDates();
                this.cdr.detectChanges();
              }
            },
            error: error => console.log(error),
            complete: () => {
              if (!this.globalService.loggedUserClass?.customerClass) return;
              if (this.globalService.loggedUserClass.customerClass.PhotoPath) {
                if (this.globalService.loggedUserClass.customerClass.PhotoPath.trim() !== '') {
                  // Invalidar cache da foto antiga antes de carregar a nova
                  if (this.globalService.loggedUserClass.customerClass.Photo) {
                    this.imageService.invalidateImageCache(this.globalService.loggedUserClass.customerClass.Photo);
                  }

                  this.subscriptions.push(
                    this.uploadService
                      .download(this.globalService.loggedUserClass.customerClass.PhotoPath)
                      .subscribe(async (file: any) => {
                        if (file && this.globalService.loggedUserClass?.customerClass) {
                          this.globalService.loggedUserClass.customerClass.Photo =
                            await this.imageService.FileToBuffer(file);
                          this.globalService.profilePhotoLoaded$.next(true);
                          this.cdr.detectChanges(); // Forçar atualização da view
                        }
                      }),
                  );
                }
              }

              if (this.globalService.loggedUserClass.customerClass.MyManager) {
                this.parseManagerData(this.globalService.loggedUserClass.customerClass.MyManager);
              } else {
                this.globalService.loggedUserClass.customerClass.useMyManagersClass = [];
                this.globalService.loggedUserClass.customerClass.MediatorServices = '';
              }

              this.baseService.onChangeName(
                this.globalService.loggedUserClass.customerClass.Name,
                this.globalService.loggedUserClass.customerClass.NIF,
              );

              this.clientareaService.ClientAreaGetCustomerShipToAddress(
                this.globalService.loggedUserClass.customerClass.idCustomer,
              );

              this.cdr.detectChanges();

              // 👇 garantir entrada/atualização da sala após carregar o cliente
              this.maybeJoinCustomerRoom();

              // 👇 carregar contas WhatsApp partilhadas (se ativo)
              if (this.globalService.loggedUserClass.customerClass.AllowWhatsApp) {
                this.loadWhatsAppSharedAccounts();
              }

              // 👇 carregar estado de associação Google OAuth
              this.loadGoogleStatus();

              // 👇 carregar/atualizar alertas da ficha de cliente
              if (this.globalService.loggedUserClass?.customerClass) {
                this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
              }
            },
          }),
      );
    }
  }

  /** Carrega o estado de ligação da conta Google para o utilizador autenticado */
  loadGoogleStatus(): void {
    if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) return;
    this.subscriptions.push(
      this.authService
        .GetGoogleStatus()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.googleStatus = {
              linked: !!res?.linked,
              googleEmail: res?.googleEmail || null,
              linkedAt: res?.linkedAt || null,
              pictureDataUrl: res?.pictureDataUrl || this.googleStatus?.pictureDataUrl || null,
              linkedProfiles: Array.isArray(res?.linkedProfiles) ? res.linkedProfiles : [],
            };
            this.cdr.detectChanges();
          },
          error: () => {
            this.googleStatus = {
              linked: false,
              googleEmail: null,
              linkedAt: null,
              pictureDataUrl: null,
              linkedProfiles: [],
            };
          },
        }),
    );
  }

  /** Abre o menu em contexto da conta Google associada (clique direito ou clique no avatar) */
  onGoogleAccountContextMenu(event: MouseEvent, trigger: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (trigger && typeof trigger.openMenu === 'function') {
      trigger.openMenu();
    }
  }

  /** Associa a foto da conta Google ao perfil do cliente autenticado */
  async associarFotoGoogleAoPerfil(): Promise<void> {
    if (this.isLoadingGoogle) return;

    const existingGooglePhoto = this.googleStatus?.pictureDataUrl;
    if (existingGooglePhoto) {
      const avatarFile = this.dataUrlToFile(existingGooglePhoto, 'google-avatar.jpg');
      if (avatarFile) {
        const cust = this.globalService.loggedUserClass?.customerClass;
        if (cust) {
          if (cust.Photo) {
            this.imageService.invalidateImageCache(cust.Photo);
          }
          const buf = await this.imageService.FileToBuffer(avatarFile);
          cust.Photo = buf || existingGooglePhoto;
          this.globalService.profilePhotoLoaded$.next(true);
          this.cdr.detectChanges();
        }
        this.uploadPhoto(avatarFile);
        const swal = await this.getSwal();
        swal.fire({
          icon: 'success',
          title: 'Foto associada ao perfil',
          text: 'A foto da sua conta Google foi aplicada ao seu perfil.',
          timer: 2200,
          showConfirmButton: false,
        });
        return;
      }
    }

    await this.sincronizarFotoGoogle(true);
  }

  /** Obtém a foto mais recente da conta Google via OAuth e opcionalmente aplica-a ao perfil */
  async sincronizarFotoGoogle(applyToProfile = true): Promise<void> {
    if (this.isLoadingGoogle) return;
    this.isLoadingGoogle = true;
    this.cdr.detectChanges();

    try {
      const accessToken = await this.authService.requestGoogleAccessToken();
      this.subscriptions.push(
        this.authService
          .LinkGoogleAccount({
            accessToken,
            linkAuthorizedNifs: this.linkAuthorizedNifs,
            forceApplyPhoto: applyToProfile,
          })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: async (res: any) => {
              this.isLoadingGoogle = false;
              const pictureUrl = res?.pictureDataUrl || this.googleStatus?.pictureDataUrl || null;
              this.googleStatus = {
                linked: true,
                googleEmail: res?.googleEmail || this.googleStatus?.googleEmail || null,
                linkedAt: this.googleStatus?.linkedAt || new Date().toISOString(),
                pictureDataUrl: pictureUrl,
                linkedProfiles: Array.isArray(res?.linkedProfiles)
                  ? res.linkedProfiles
                  : this.googleStatus?.linkedProfiles || [],
              };

              if (applyToProfile && pictureUrl) {
                const cust = this.globalService.loggedUserClass?.customerClass;
                const avatarFile = this.dataUrlToFile(pictureUrl, 'google-avatar.jpg');
                if (cust) {
                  if (cust.Photo) {
                    this.imageService.invalidateImageCache(cust.Photo);
                  }
                  const buf = avatarFile ? await this.imageService.FileToBuffer(avatarFile) : null;
                  cust.Photo = buf || pictureUrl;
                  if (res?.savedPhotoPath) {
                    cust.PhotoPath = res.savedPhotoPath;
                  } else if (avatarFile) {
                    this.uploadPhoto(avatarFile);
                  }
                  this.globalService.profilePhotoLoaded$.next(true);
                }
              }

              this.cdr.detectChanges();
              const swal = await this.getSwal();
              swal.fire({
                icon: 'success',
                title: applyToProfile ? 'Foto associada ao perfil' : 'Foto Google atualizada',
                text: applyToProfile
                  ? 'A foto da sua conta Google foi atualizada e aplicada ao seu perfil.'
                  : 'A foto da sua conta Google foi sincronizada.',
                timer: 2200,
                showConfirmButton: false,
              });
            },
            error: (err: any) => {
              this.isLoadingGoogle = false;
              this.cdr.detectChanges();
              this.getSwal().then(swal =>
                swal.fire({
                  icon: 'warning',
                  title: 'Atenção',
                  text: err?.error?.message || 'Não foi possível obter a foto da conta Google.',
                }),
              );
            },
          }),
      );
    } catch (err: any) {
      this.isLoadingGoogle = false;
      this.cdr.detectChanges();
      const message = err?.message || '';
      if (message && !message.includes('cancelada')) {
        this.getSwal().then(swal =>
          swal.fire({
            icon: 'warning',
            title: 'Autenticação Google',
            text: message,
          }),
        );
      }
    }
  }

  /** Inicia o fluxo seguro OAuth 2.0 para associar a conta Google ao NIF atual (e perfis autorizados) */
  async associarContaGoogle(): Promise<void> {
    if (this.isLoadingGoogle) return;
    this.isLoadingGoogle = true;
    this.cdr.detectChanges();

    try {
      const accessToken = await this.authService.requestGoogleAccessToken();
      this.subscriptions.push(
        this.authService
          .LinkGoogleAccount({
            accessToken,
            linkAuthorizedNifs: this.linkAuthorizedNifs,
          })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (res: any) => {
              this.isLoadingGoogle = false;
              this.googleStatus = {
                linked: true,
                googleEmail: res?.googleEmail || null,
                linkedAt: new Date().toISOString(),
                pictureDataUrl: res?.pictureDataUrl || this.googleStatus?.pictureDataUrl || null,
                linkedProfiles: Array.isArray(res?.linkedProfiles) ? res.linkedProfiles : [],
              };

              // Se o cliente ainda não tiver foto de perfil e o Google devolveu foto sanitizada, assumir automaticamente
              const cust = this.globalService.loggedUserClass?.customerClass;
              const hasExistingPhoto = !!(cust?.Photo || (cust?.PhotoPath && cust.PhotoPath.trim() !== ''));
              if (!hasExistingPhoto && res?.pictureDataUrl) {
                if (res?.savedPhotoPath && cust) {
                  cust.PhotoPath = res.savedPhotoPath;
                  cust.Photo = res.pictureDataUrl;
                  this.globalService.profilePhotoLoaded$.next(true);
                } else {
                  const avatarFile = this.dataUrlToFile(res.pictureDataUrl, 'google-avatar.jpg');
                  if (avatarFile) {
                    this.uploadPhoto(avatarFile);
                  }
                }
              }

              // Se o cliente não tiver email preenchido na ficha, sugerir o email verificado da Google
              if (cust && (!cust.Email || cust.Email.trim() === '') && res?.googleEmail) {
                cust.Email = res.googleEmail;
              }

              this.cdr.detectChanges();
              this.getSwal().then(swal =>
                swal.fire({
                  icon: 'success',
                  title: 'Conta Google associada',
                  text: res?.message || 'A sua conta Google foi associada com sucesso.',
                }),
              );
            },
            error: (err: any) => {
              this.isLoadingGoogle = false;
              this.cdr.detectChanges();
              const msg =
                err?.error?.message || 'Não foi possível associar a conta Google. Tente novamente mais tarde.';
              this.getSwal().then(swal =>
                swal.fire({
                  icon: 'warning',
                  title: 'Atenção',
                  text: msg,
                }),
              );
            },
          }),
      );
    } catch (err: any) {
      this.isLoadingGoogle = false;
      this.cdr.detectChanges();
      const message = err?.message || '';
      if (message && !message.includes('cancelada')) {
        this.getSwal().then(swal =>
          swal.fire({
            icon: 'warning',
            title: 'Autenticação Google',
            text: message,
          }),
        );
      }
    }
  }

  /** Desassocia a conta Google do NIF atual ou de todos os NIFs associados */
  async desassociarContaGoogle(unlinkAll = false): Promise<void> {
    if (this.isLoadingGoogle) return;
    const swal = await this.getSwal();
    const confirmResult = await swal.fire({
      icon: 'question',
      title: unlinkAll ? 'Desassociar de todos os NIFs?' : 'Desassociar Conta Google?',
      text: unlinkAll
        ? 'A sua conta Google deixará de estar associada a todos os seus NIFs no SegurosVirtual.'
        : 'Deixará de poder iniciar sessão direta com Google neste NIF, mantendo o acesso normal por palavra-passe.',
      showCancelButton: true,
      confirmButtonText: 'Sim, desassociar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmResult.isConfirmed) return;

    this.isLoadingGoogle = true;
    this.cdr.detectChanges();

    this.subscriptions.push(
      this.authService
        .UnlinkGoogleAccount(unlinkAll)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.isLoadingGoogle = false;
            this.loadGoogleStatus();
            swal.fire({
              icon: 'success',
              title: 'Conta Google desassociada',
              text: res?.message || 'A associação com a conta Google foi removida.',
            });
          },
          error: (err: any) => {
            this.isLoadingGoogle = false;
            this.cdr.detectChanges();
            swal.fire({
              icon: 'error',
              title: 'Erro',
              text: err?.error?.message || 'Não foi possível desassociar a conta Google.',
            });
          },
        }),
    );
  }

  private dataUrlToFile(dataUrl: string, filename: string): File | null {
    try {
      const arr = dataUrl.split(',');
      if (arr.length < 2) return null;
      const mimeMatch = arr[0].match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    } catch {
      return null;
    }
  }

  async uploadCartaoCidadao() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    let uploadFilesClass: UploadFilesClass;
    uploadFilesClass = new UploadFilesClass();
    uploadFilesClass.TitleForm = this.t.instant('USERMENU.DOCS_TITLE_FORM');
    uploadFilesClass.FolderName = 'CustomerFiles';
    uploadFilesClass.maxAllowedfiles = environment.maxAllowedfiles;
    uploadFilesClass.idCustomer = this.globalService.loggedUserClass.customerClass.idCustomer;
    uploadFilesClass.NIF = this.globalService.loggedUserClass.customerClass.NIF;
    uploadFilesClass.idProduct = null;
    uploadFilesClass.idProductsTypes = null;
    uploadFilesClass.contextType = 'clientarea';

    if (!this.validateNifService.isNIFEmpresa(this.globalService.loggedUserClass.customerClass.NIF)) {
      uploadFilesClass.comment = this.t.instant('USERMENU.DOCS_HELP_PERSONAL');
    } else {
      uploadFilesClass.comment = this.t.instant('USERMENU.DOCS_HELP_COMPANY');
    }

    this.subscriptions.push(
      this.customerService
        .ClientAreaGetCustomerFilesCitizenCard(this.globalService.loggedUserClass.customerClass.idCustomer)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: dados => {
            ((this.globalService.loggedUserClass.customerClass.customerFilesCitizenCardClass = dados),
              (uploadFilesClass.filesClass = dados));
          },
          error: error => {
            if (window.navigator.onLine) {
              this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
            }
            console.log(error);
          },
          complete: () => {
            window.history.pushState(null, null, window.location.href);
            import('../documents/documents.component').then(module => {
              let dialogRef: any;
              if (this.globalService.isMobileDevice) {
                dialogRef = this.dialog.open(module.DocumentsComponent, {
                  data: uploadFilesClass,
                  maxWidth: '100vw',
                  height: '100%',
                  width: '100%',
                });
              } else {
                dialogRef = this.dialog.open(module.DocumentsComponent, { data: uploadFilesClass });
              }

              dialogRef.autoFocus = false;
              dialogRef.disableClose = true;

              dialogRef
                .afterClosed()
                .pipe(takeUntil(this.destroy$))
                .subscribe(result => {
                  console.log(result);

                  if (result) {
                    this.subscriptions.push(
                      this.customerService
                        .ClientAreaSetCustomerFilesCitizenCard(result)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe({
                          next: dados =>
                            (this.globalService.loggedUserClass.customerClass.customerFilesCitizenCardClass = dados),
                          error: error => {
                            if (window.navigator.onLine) {
                              this.getSwal().then(swal =>
                                swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                              );
                            }
                            console.log(error);
                          },
                          complete: () => {
                            this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
                            this.subscriptions.push(
                              this.customerService
                                .ClientAreaGetCustomerFilesCitizenCard(
                                  this.globalService.loggedUserClass.customerClass.idCustomer,
                                )
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                  next: dados => {
                                    ((this.globalService.loggedUserClass.customerClass.customerFilesCitizenCardClass =
                                      dados),
                                      (uploadFilesClass.filesClass = dados));
                                  },
                                  error: error => {
                                    if (window.navigator.onLine) {
                                      this.getSwal().then(swal =>
                                        swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                                      );
                                    }
                                    console.log(error);
                                  },
                                }),
                            );
                          },
                        }),
                    );
                  }
                });
            });
          },
        }),
    );
  }

  filter(value: string) {
    const filterValue = value.toLowerCase();
    this.professions = this.globalService.professionalsituationClass.filter(
      option => option.Description.toLowerCase().indexOf(filterValue) > -1,
    );
  }

  filteratividade(value: string) {
    const filterValue = value.toLowerCase();
    this.commonCAE = this.globalService.commonCAEClass.filter(
      option => option.ATIVIDADE.toLowerCase().indexOf(filterValue) > -1,
    );
  }

  logout() {
    this.authService.logout();
  }

  get hasProfilePhoto(): boolean {
    const cust = this.globalService.loggedUserClass?.customerClass;
    const comm = this.globalService.loggedUserClass?.commercialClass;
    return !!(cust?.Photo || (cust?.PhotoPath && cust.PhotoPath.trim() !== '') || comm?.Photo);
  }

  get currentPhotoUrl(): string | SafeUrl | null {
    const photo =
      this.globalService.loggedUserClass?.customerClass?.Photo ||
      this.globalService.loggedUserClass?.commercialClass?.Photo;
    if (!photo) return null;
    return this.imageService.ConvertImageToURL(photo);
  }

  openPhotoContextMenu(event: MouseEvent, trigger: MatMenuTrigger): void {
    event.preventDefault();
    event.stopPropagation();
    if (trigger && !trigger.menuOpen) {
      trigger.openMenu();
    }
  }

  async onPhotoFileSelected(event: any): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    input.value = '';
    if (!this.imageService.isImageFile(file)) {
      const swal = await this.getSwal();
      swal.fire({ icon: 'error', text: this.t.instant('USERMENU.PHOTO_MENU.INVALID_IMAGE') });
      return;
    }
    this.uploadPhoto(file);
  }

  onViewPhoto(): void {
    const url = this.currentPhotoUrl;
    if (url) {
      const name =
        this.globalService.loggedUserClass?.customerClass?.firstLastName ||
        this.globalService.loggedUserClass?.customerClass?.Name ||
        this.globalService.loggedUserClass?.commercialClass?.Name ||
        '';
      this.profilePhotoService.openPhotoView(url, name);
    }
  }

  async onRemovePhoto(): Promise<void> {
    const confirmed = await this.profilePhotoService.confirmRemovePhoto();
    if (!confirmed) return;

    const cust = this.globalService.loggedUserClass?.customerClass;
    if (!cust) return;

    if (cust.Photo) {
      this.imageService.invalidateImageCache(cust.Photo);
    }
    cust.Photo = null;
    cust.PhotoPath = null;
    cust.PhotoType = null;
    cust.PhotoSize = null;

    this.save(true);
    this.authService.saveSession(this.globalService.loggedUserClass);
    this.globalService.profilePhotoLoaded$.next(true);
    this.outuserPhoto.emit(null as any);
    const swal = await this.getSwal();
    swal.fire({
      icon: 'success',
      title: this.t.instant('USERMENU.PHOTO_MENU.REMOVE_SUCCESS'),
      timer: 2000,
      showConfirmButton: false,
    });
  }

  async onTakePicture() {
    window.history.pushState(null, null, window.location.href);
    const module = await import('../../../shared/components/takesnapshots/takesnapshots.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.TakesnapshotsComponent, { maxWidth: '100vw', height: '100%', width: '100%' });
    } else {
      dialogRef = this.dialog.open(module.TakesnapshotsComponent);
    }
    dialogRef.autoFocus = false;

    let imagem: File;
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        dados => {
          imagem = dados;
        },
        error => {
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
        () => {
          if (imagem) {
            this.uploadPhoto(imagem);
          }
        },
      );
  }

  uploadPhoto(file: File) {
    let uploadResult: any;

    if (file) {
      if (this.imageService.isImageFile(file)) {
        this.imageService
          .resizeImage(file, 40 * 1024)
          .then(resizedFile => {
            const targetNif = (
              this.globalService.loggedUserClass?.customerClass?.NIF ||
              this.globalService.loggedUserClass?.NIF ||
              ''
            ).trim();
            this.subscriptions.push(
              this.uploadService
                .upload(resizedFile, targetNif, 'photo')
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (progress: HttpEvent<Object>) => {
                    if (progress.type === HttpEventType.Response) {
                      console.log('Upload concluído.');
                      uploadResult = progress.body;
                    }
                  },
                  error: error => {
                    if (window.navigator.onLine) {
                      this.getSwal().then(swal =>
                        swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                      );
                    }
                    console.log(error);
                  },
                  complete: () => {
                    if (!this.globalService.loggedUserClass?.customerClass) return;
                    this.globalService.loggedUserClass.customerClass.PhotoPath = uploadResult.path.replace(
                      environment.uploadFoldertmp,
                      '',
                    );
                    this.globalService.loggedUserClass.customerClass.PhotoType = uploadResult.type;
                    this.globalService.loggedUserClass.customerClass.PhotoSize = uploadResult.size;
                    this.imageService.FileToBuffer(resizedFile).then(buffer => {
                      if (this.globalService.loggedUserClass?.customerClass) {
                        this.globalService.loggedUserClass.customerClass.Photo = buffer;
                        this.cdr.detectChanges();
                      }
                    });
                    this.save(true);
                    this.authService.saveSession(this.globalService.loggedUserClass);
                    this.globalService.profilePhotoLoaded$.next(true);
                    this.outuserPhoto.emit(null as any);
                    this.getSwal().then(swal => {
                      swal.fire({
                        icon: 'success',
                        title: this.t.instant('USERMENU.PHOTO_MENU.UPDATE_SUCCESS'),
                        timer: 2000,
                        showConfirmButton: false,
                      });
                    });
                  },
                }),
            );
          })
          .catch(error => {
            console.log('Erro ao redimensionar a imagem:', error);
          });
      } else {
        console.log('O arquivo não é uma imagem.');
      }
    }
  }

  refreshShipToAddress() {
    if (!this.globalService.loggedUserClass?.customerClass?.idCustomer) return;
    this.showSpinnerShipToAddress = true;

    this.subscriptions.push(
      this.customerService
        .ClientAreaGetCustomerShipToAddress(this.globalService.loggedUserClass.customerClass.idCustomer)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: dados => {
            if (this.globalService.loggedUserClass?.customerClass) {
              this.globalService.loggedUserClass.customerClass.customerShipToAddressClass = dados;
            }
          },
          error: error => console.log(error),
          complete: () => {
            if (this.globalService.loggedUserClass?.customerClass) {
              this.tempcustomerShipToAddressClass =
                this.globalService.loggedUserClass.customerClass.customerShipToAddressClass?.find(
                  d => d.idShipToAddress === this.globalService.loggedUserClass.customerClass.idShipToAddressDefault,
                );
            }

            this.showSpinnerShipToAddress = false;
          },
        }),
    );
  }

  async onCheckshiptoaddress() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    if (this.globalService.loggedUserClass.customerClass.customerShipToAddressClass.length === 0) {
      this.onAddshiptoaddress();
    } else {
      if (this.globalService.loggedUserClass.customerClass.idShipToAddressDefault === null) {
        return;
      }

      if (this.globalService.loggedUserClass.customerClass.customerShipToAddressClass.length === 1) {
        this.tempcustomerShipToAddressClass.Default = 1;
      }

      window.history.pushState(null, null, window.location.href);

      const module = await import('src/app/pages/clientarea/clientshiptoaddress/clientshiptoaddress.component');
      let dialogRef: any;
      if (this.globalService.isMobileDevice) {
        dialogRef = this.dialog.open(module.ClientshiptoaddressComponent, {
          data: this.tempcustomerShipToAddressClass,
          maxWidth: '100vw',
          height: '100%',
          width: '100%',
        });
      } else {
        dialogRef = this.dialog.open(module.ClientshiptoaddressComponent, {
          data: this.tempcustomerShipToAddressClass,
        });
      }

      dialogRef.autoFocus = false;
      dialogRef.disableClose = true;
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          () =>
            this.clientareaService.ClientAreaGetCustomerShipToAddress(
              this.globalService.loggedUserClass.customerClass.idCustomer,
            ),
          error => {
            if (window.navigator.onLine) {
              this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
            }
            console.log(error);
          },
        );
    }
  }

  async onAddshiptoaddress() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    let customerShipToAddressClass = new CustomerShipToAddressClass();
    customerShipToAddressClass.idCustomer = this.globalService.loggedUserClass.customerClass.idCustomer;

    window.history.pushState(null, null, window.location.href);

    const module = await import('src/app/pages/clientarea/clientshiptoaddress/clientshiptoaddress.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.ClientshiptoaddressComponent, {
        data: customerShipToAddressClass,
        maxWidth: '100vw',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.ClientshiptoaddressComponent);
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        result => (customerShipToAddressClass = result),
        error => {
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
        () => {
          if (this.globalService.loggedUserClass?.customerClass?.idCustomer) {
            this.clientareaService.ClientAreaGetCustomerShipToAddress(
              this.globalService.loggedUserClass.customerClass.idCustomer,
            );
          }
        },
      );
  }

  onremoveshiptoaddress() {
    if (!this.globalService.loggedUserClass?.customerClass?.customerShipToAddressClass) {
      return;
    }

    let tempMorada: CustomerShipToAddressClass[];
    tempMorada = this.globalService.loggedUserClass.customerClass.customerShipToAddressClass;
    let morada: CustomerShipToAddressClass;

    morada = tempMorada.find(
      m => this.globalService.loggedUserClass.customerClass.idShipToAddressDefault === m.idShipToAddress,
    );

    this.getSwal().then(swal =>
      swal
        .fire({
          title: this.t.instant('USERMENU.ADDRESS_TITLE_HTML'),
          icon: 'warning',
          html:
            this.t.instant('USERMENU.DELETE_ADDRESS_PROMPT') +
            morada.AddressDetail +
            ' <br> ' +
            morada.PostalCode +
            '  ' +
            morada.Region,
          confirmButtonText: this.t.instant('USERMENU.DELETE'),
          showCancelButton: true,
          reverseButtons: true,
          focusConfirm: false,
        })
        .then(result => {
          if (result.isConfirmed) {
            morada.DateEnd = new Date();
            this.subscriptions.push(
              this.customerService
                .ClientAreaSetCustomerShipToAddress(morada, this.globalService.loggedUserClass.UUID)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  error: error => {
                    if (window.navigator.onLine) {
                      this.getSwal().then(swal =>
                        swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                      );
                    }
                    console.log(error);
                  },
                  complete: () => {
                    this.globalService.loggedUserClass.customerClass.idShipToAddressDefault = null;
                    this.globalService.loggedUserClass.customerClass.AddressDetail = '';
                    this.globalService.loggedUserClass.customerClass.PostalCode = '';
                    this.globalService.loggedUserClass.customerClass.Region = '';

                    this.subscriptions.push(
                      this.customerService
                        .ClientAreaGetCustomerShipToAddress(this.globalService.loggedUserClass.customerClass.idCustomer)
                        .pipe(takeUntil(this.destroy$))
                        .subscribe({
                          next: dados =>
                            (this.globalService.loggedUserClass.customerClass.customerShipToAddressClass = dados),
                          error: error => {
                            if (window.navigator.onLine) {
                              this.getSwal().then(swal =>
                                swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                              );
                            }
                            console.log(error);
                          },
                        }),
                    );

                    this.getSwal().then(swal =>
                      swal.fire({ icon: 'success', text: this.t.instant('USERMENU.ADDRESS_DELETED') }),
                    );
                  },
                }),
            );
          }
        }),
    );
  }

  onChangeshiptoaddress(idShipToAddress: number) {
    if (!idShipToAddress || idShipToAddress === undefined) {
      this.tempcustomerShipToAddressClass = new CustomerShipToAddressClass();
    } else {
      this.tempcustomerShipToAddressClass =
        this.globalService.loggedUserClass?.customerClass?.customerShipToAddressClass?.find(
          d => d.idShipToAddress === idShipToAddress,
        );
    }

    this.save(true);
  }

  openBirthdate() {
    this.Birthdate.open();
    this.Birthdate.nativeElement.focus();
  }

  openDrivinglicenseDate() {
    this.DrivinglicenseDate.open();
  }

  async findNIB() {
    window.history.pushState(null, null, window.location.href);
    const module = await import('../nib/nib.component');
    const idCustomer =
      this.globalService.loggedUserClass?.customerClass?.idCustomer ?? this.globalService.loggedUserClass?.idCustomer;
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.NibComponent, {
        data: idCustomer,
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.NibComponent, { data: idCustomer });
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        result => {
          if (result && this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.NIB = result.IBAN;
            this.save(true);
          }
        },
        error => {
          this.showProgress = false;
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
      );
  }

  async findEmails() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    window.history.pushState(null, null, window.location.href);
    const module = await import('../customeremails/customeremails.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.CustomeremailsComponent, {
        data: this.globalService.loggedUserClass.customerClass.idCustomer,
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.CustomeremailsComponent, {
        data: this.globalService.loggedUserClass.customerClass.idCustomer,
      });
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result: CustomerEmail) => {
          if (result && this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.Email = result.EmailAddress;
            this.save(true);
          }
        },
        error => {
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
      );
  }

  async findshipaddress() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    console.log(this.globalService.loggedUserClass.idCustomer);
    window.history.pushState(null, null, window.location.href);
    const module = await import('../findshiptoaddress/findshiptoaddress.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.FindshiptoaddressComponent, {
        data: this.globalService.loggedUserClass.customerClass.idCustomer,
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.FindshiptoaddressComponent, {
        data: this.globalService.loggedUserClass.customerClass.idCustomer,
      });
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        result => {
          console.log(result);
          if (result && this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.idShipToAddressDefault = result.idShipToAddress;
            this.globalService.loggedUserClass.customerClass.AddressDetail = result.AddressDetail;
            this.globalService.loggedUserClass.customerClass.PostalCode = result.PostalCode;
            this.globalService.loggedUserClass.customerClass.Region = result.Region;
            this.save(true);
          }
        },
        error => {
          this.showProgress = false;
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
      );
  }

  addManager() {
    this.MyManagersAddForm = true;
    this.ManagersClass = new UserMyManagersClass();
    this.ManagersClass.Name = '';
    this.ManagersClass.Photo = null;
    this.ManagersClass.Info = '';

    this.ManagersClass.DateStart = new Date();
    this.ManagersClass.DateEnd = null;
    this.ManagersClass.Default = false;

    this.ManagersClass.userMyManagersContactsClass = [];
    this.ManagersClass.userMyManagersEmailsClass = [];

    this.telMyManagersContactsClass = new UserMyManagersContactsClass();
    this.telMyManagersContactsClass.TypeContact = 'Telemóvel';
    this.telMyManagersContactsClass.Contact = '';

    this.ManagersClass.userMyManagersContactsClass.push(new UserMyManagersContactsClass());
    this.ManagersClass.userMyManagersContactsClass[this.ManagersClass.userMyManagersContactsClass.length - 1] =
      this.telMyManagersContactsClass;

    this.emailUserMyManagersContactsClass = new UserMyManagersContactsClass();
    this.emailUserMyManagersContactsClass.TypeContact = 'Pessoal';
    this.emailUserMyManagersContactsClass.Contact = '';

    this.ManagersClass.userMyManagersEmailsClass.push(new UserMyManagersContactsClass());
    this.ManagersClass.userMyManagersEmailsClass[this.ManagersClass.userMyManagersEmailsClass.length - 1] =
      this.emailUserMyManagersContactsClass;

    this.showButtonSave = true;
    this.showButtonAdd = !this.showButtonSave;
  }

  saveanager(refresh: boolean) {
    const customerClass = this.globalService.loggedUserClass?.customerClass;
    if (!customerClass) return;
    customerClass.useMyManagersClass.push(new UserMyManagersClass());
    customerClass.useMyManagersClass[customerClass.useMyManagersClass.length - 1] = this.ManagersClass;
    this.serializeManagerData();
    this.MyManagersAddForm = false;
    this.showButtonSave = false;
    this.showButtonAdd = !this.showButtonSave;

    this.save(refresh);
  }

  cancelanager() {
    this.MyManagersAddForm = false;
    this.showButtonSave = false;
    this.showButtonAdd = !this.showButtonSave;
    this.refresh();
  }

  deleteManager(index) {
    this.getSwal().then(swal =>
      swal
        .fire({
          title: this.t.instant('USERMENU.CONFIRM_DELETE_MANAGER_CONTACT'),
          text: '',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#3085d6',
          confirmButtonColor: '#d33',
          cancelButtonText: this.t.instant('USERMENU.CANCEL'),
          confirmButtonText: this.t.instant('USERMENU.DELETE'),
          reverseButtons: true,
        })
        .then(result => {
          if (result.isConfirmed && this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.useMyManagersClass.splice(index, 1);
            this.serializeManagerData();
            this.MyManagersAddForm = false;
            this.showButtonSave = false;
            this.showButtonAdd = !this.showButtonSave;

            this.save(true);
          }
        }),
    );
  }

  deleteuserMyManagersContactsClass(indexOfelement, index) {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    this.globalService.loggedUserClass.customerClass.useMyManagersClass[
      indexOfelement
    ].userMyManagersContactsClass.splice(index, 1);
    this.serializeManagerData();
    this.MyManagersAddForm = false;
    this.showButtonSave = false;
    this.showButtonAdd = !this.showButtonSave;
    this.save(false);
  }

  deleteuseruserMyManagersEmailsClass(indexOfelement, index) {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    this.globalService.loggedUserClass.customerClass.useMyManagersClass[
      indexOfelement
    ].userMyManagersEmailsClass.splice(index, 1);
    this.serializeManagerData();
    this.MyManagersAddForm = false;
    this.showButtonSave = false;
    this.showButtonAdd = !this.showButtonSave;
    this.save(false);
  }

  addEmptyContact(indexOfelement) {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    let addrow: boolean = false;
    let l: number = 0;

    if (
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass
        .length
    ) {
      l =
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass
          .length - 1;
    }

    if (
      l === 0 ||
      !this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass
        .length
    ) {
      addrow = true;
    } else {
      if (
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass[
          l
        ].Contact.trim() !== ''
      ) {
        addrow = true;
      }
    }

    if (addrow) {
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[
        indexOfelement
      ].userMyManagersContactsClass.push(new UserMyManagersContactsClass());
      if (
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass
          .length
      ) {
        l =
          this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement]
            .userMyManagersContactsClass.length - 1;
      }
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass[
        l
      ].TypeContact = 'Telemóvel';
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersContactsClass[
        l
      ].Contact = '';
    }
  }

  addEmptyEmail(indexOfelement) {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    let addrow: boolean = false;
    let l: number = 0;

    if (
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass
        .length
    ) {
      l =
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass
          .length - 1;
    }

    if (
      l === 0 ||
      !this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass
        .length
    ) {
      addrow = true;
    } else {
      if (
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass[
          l
        ].Contact.trim() !== ''
      ) {
        addrow = true;
      }
    }

    if (addrow) {
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[
        indexOfelement
      ].userMyManagersEmailsClass.push(new UserMyManagersContactsClass());
      if (
        this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass
          .length
      ) {
        l =
          this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass
            .length - 1;
      }
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass[
        l
      ].TypeContact = 'Pessoal';
      this.globalService.loggedUserClass.customerClass.useMyManagersClass[indexOfelement].userMyManagersEmailsClass[
        l
      ].Contact = '';
    }
  }

  async configLayout() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    window.history.pushState(null, null, window.location.href);
    const module = await import('../configlayout/configlayout.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.ConfiglayoutComponent, {
        data: this.globalService.customerLayoutClass,
        maxWidth: '100vw',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.ConfiglayoutComponent, { data: this.globalService.customerLayoutClass });
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: CustomerLayoutClass[]) => {
        if (!this.globalService.loggedUserClass?.customerClass) return;
        if (result) {
          for (let i = 0; i < result.length; i++) {
            result[i].idCustomer = this.globalService.loggedUserClass.customerClass.idCustomer;
            result[i].Order = i;
            this.subscriptions.push(
              this.commonService
                .ClientAreaSetCustomerLayoutClientArea(result[i], this.globalService.loggedUserClass.UUID)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  error: error => {
                    this.getSwal().then(swal =>
                      swal.fire({ icon: 'error', text: this.t.instant('USERMENU.REQUEST_FAILED') }),
                    );
                    console.log(error);
                  },
                }),
            );
          }

          this.subscriptions.push(
            this.customerService
              .ClientAreaGetCustomerLayout(this.globalService.loggedUserClass.customerClass.idCustomer)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: layout => (this.globalService.customerLayoutClass = layout),
                error: error => {
                  console.log(error);
                },
              }),
          );
        } else {
          this.subscriptions.push(
            this.customerService
              .ClientAreaGetCustomerLayout(this.globalService.loggedUserClass.customerClass.idCustomer)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: layout => (this.globalService.customerLayoutClass = layout),
                error: error => {
                  console.log(error);
                },
              }),
          );
        }
      });

    this.maybeJoinCustomerRoom();
  }

  async addStar() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    window.history.pushState(null, null, window.location.href);
    const module = await import('../interests/interests.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.InterestsComponent, {
        data: this.globalService.loggedUserClass.customerClass,
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.InterestsComponent, {
        data: this.globalService.loggedUserClass.customerClass,
      });
    }

    dialogRef.autoFocus = true;
    dialogRef.disableClose = true;

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        _result => {},
        error => {
          this.showProgress = false;
          if (window.navigator.onLine) {
            this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
          }
          console.log(error);
        },
      );
  }

  async NifautorizationComponent() {
    window.history.pushState(null, null, window.location.href);
    const module = await import('../nifautorization/nifautorization.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.NifautorizationComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.NifautorizationComponent);
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (this.globalService.loggedUserClass?.customerClass) {
          this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
        }

        // Scroll direto para o topo após fechar o dialog (delay para garantir que acontece após Material terminar)
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'auto' });
        }, 100);

        if (result && this.globalService.loggedUserClass?.customerClass) {
          this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
        }
        this.refresh(false);
        this.cdr.detectChanges();
      });
  }

  async openCustomerSchedule() {
    window.history.pushState(null, null, window.location.href);
    const module = await import('../customerschedule/customerschedule.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.CustomerscheduleComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.CustomerscheduleComponent);
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (this.globalService.loggedUserClass?.customerClass) {
          this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
        }
        setTimeout(() => {
          if (result && this.globalService.loggedUserClass?.customerClass) {
            this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass);
          }
        });
      });
  }

  change() {
    this.router.navigate(['/login/changepassword'], { skipLocationChange: false });
  }

  async drivecategory() {
    if (!this.globalService.loggedUserClass?.customerClass) return;
    window.history.pushState(null, null, window.location.href);
    const module = await import('../customerdrivecategory/customerdrivecategory.component');
    let dialogRef: any;
    if (this.globalService.isMobileDevice) {
      dialogRef = this.dialog.open(module.CustomerdrivecategoryComponent, {
        data: this.globalService.loggedUserClass.customerClass,
        maxWidth: '100vw',
        height: '100%',
        width: '100%',
      });
    } else {
      dialogRef = this.dialog.open(module.CustomerdrivecategoryComponent, {
        data: this.globalService.loggedUserClass.customerClass,
        width: '840px',
        maxWidth: '95vw',
        maxHeight: '92vh',
      });
    }

    dialogRef.autoFocus = false;
    dialogRef.disableClose = true;

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result && this.globalService.loggedUserClass) {
          console.log(result);
          const prevPhotoDrive = this.globalService.loggedUserClass.customerClass?.Photo;
          const prevPhotoPathDrive = this.globalService.loggedUserClass.customerClass?.PhotoPath;
          this.globalService.loggedUserClass.customerClass = Object.assign(new CustomerClass(), result);
          // Restaurar foto se o resultado do dialog não trouxe blob e o PhotoPath for coincidente
          if (!this.globalService.loggedUserClass.customerClass.PhotoPath?.trim()) {
            this.globalService.loggedUserClass.customerClass.Photo = null;
          } else if (
            prevPhotoDrive &&
            !this.globalService.loggedUserClass.customerClass.Photo &&
            this.globalService.loggedUserClass.customerClass.PhotoPath === prevPhotoPathDrive
          ) {
            this.globalService.loggedUserClass.customerClass.Photo = prevPhotoDrive;
          } else {
            this.globalService.loggedUserClass.customerClass.Photo = null;
          }
          this.save(true);
          this.authService.saveSession(this.globalService.loggedUserClass);
        }
      });
  }

  onTouchStart() {
    const currentTime = new Date().getTime();
    const timeSinceLastTouch = currentTime - this.lastTouchTime;

    if (timeSinceLastTouch <= this.doubleClickThreshold) {
      this.drivecategory();
    }

    this.lastTouchTime = currentTime;
  }

  /** Partilhar contacto do mediador via Web Share API ou Clipboard */
  async shareMediatorContact() {
    const commercial = this.globalService.loggedUserClass?.commercialClass;
    if (!commercial) return;

    const lines: string[] = [
      commercial.Name || '',
      commercial.NIF ? `NIF: ${commercial.NIF}` : '',
      commercial.Contact ? `Tel: ${commercial.Contact}` : '',
      commercial.Email ? `Email: ${commercial.Email}` : '',
      commercial.Office ? commercial.Office : '',
    ].filter(l => l.length > 0);

    const text = lines.join('\n');

    if (navigator.share) {
      try {
        await navigator.share({ title: commercial.Name, text });
      } catch (_) {
        // Utilizador cancelou a partilha
      }
    } else {
      // Fallback: copiar para clipboard
      try {
        await navigator.clipboard.writeText(text);
        this.alerts.success('USERMENU.CONTACT_COPIED', 'COMMON.ALERTS.SUCCESS');
      } catch (_) {
        console.error('Não foi possível copiar para o clipboard');
      }
    }
  }

  // trackBy functions para otimização de performance
  trackByIndex(index: number): number {
    return index;
  }

  trackById(index: number, item: any): any {
    return item?.id ?? item?.idSexTypes ?? item?.idMaritalStatus ?? index;
  }

  trackByManager(index: number, item: UserMyManagersClass): string {
    return item?.codigo ?? index.toString();
  }
}
